import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { Session } from 'src/app/models/session';
import { SpaceRepository } from 'src/app/state/space.repository';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class SpaceActionRulesService {
  constructor(
    private translateService: TranslateService,
    private spaceRepo: SpaceRepository,
    private userService: UserService,
  ) {}

  readonly renameActiveSpaceDisabledReason$ = this.spaceRepo.activeSpace$.pipe(
    map((space) => this.getRenameDisabledReasonForHostUser(space)),
    distinctUntilChanged(),
  );

  // Rename — `null` when rename is permitted; otherwise the translated reason renaming is blocked.
  // Assumes the viewer is a host (not a participant); this does not check role.
  getRenameDisabledReasonForHostUser(space: Session | undefined): string | null {
    if (space?.cohort) {
      return this.translateService.instant(
        "This Space can't be renamed because it's linked to a Cohort",
      );
    }
    return null;
  }

  // Delete — `null` when the current user may delete; otherwise the translated reason deletion is blocked.
  getCurrentUserCannotDeleteSpaceReason(space: Session | undefined): string | null {
    if (space?.cohort) {
      return this.translateService.instant(
        "This Space can't be deleted because it's linked to a Cohort",
      );
    }
    const user = this.userService.user.getValue()?.user;
    if (!this.spaceRepo.isSpaceOwnerOrAdmin(user, space)) {
      return this.translateService.instant('Only the Space owner can delete this Space');
    }
    if (space?.isTemplate) {
      return this.translateService.instant('The Space is used as a template and cannot be deleted');
    }

    return null;
  }
}
